<script>
    import Loader from './Components/Loader.svelte'
    import AssessmentTypeModel from './Models/assessmentTypeModel'
    import AssessmentTypeNav from './Components/AssessmentTypeNav.svelte';

    import LibraryTagModel from './Models/LibraryTagModel';
    import { faBook } from "@fortawesome/free-solid-svg-icons";
    import Fa from "svelte-fa";

    import {notifier} from "@beyonk/svelte-notifications"

    export let params;

    let assessment_type_model, assessment_type;
    let button_toggle = {};

    function loadAssessmentType(assessment_type_id) {
        assessment_type_model = new AssessmentTypeModel(assessment_type_id);
        assessment_type = assessment_type_model.store;
    }

    let library_tags = LibraryTagModel.getList()

    function addTag(e) {
        let tag_data = {
            color_class: e.target.elements.color_class.value,
            name: e.target.elements.name.value
        }

        if (tag_data.name == "") return;

        e.target.elements.name.value = ""

        assessment_type_model.addTag(tag_data);
    }

    function addLibraryTag(tag) {
        // check if library tag already exists
        for (let existing_tag of $assessment_type.question_tags) {
            if (existing_tag.library_id == tag._id) {
                notifier.danger("Tag Already Exists");
                return;
            }
        }

        let tag_data = {
            tag_id: tag.item_id,
            color_class: tag.color,
            name: tag.name,
            library_id: tag._id
        }

        assessment_type_model.addTag(tag_data);
    }

    function removeTag(tag) {
        assessment_type_model.deleteTag(tag)
    }

    function addCommentTag(e) {
        let tag_data = {
            color_class: e.target.elements.color_class.value,
            name: e.target.elements.name.value
        }

        if (tag_data.name == "") return;

        e.target.elements.name.value = ""

        assessment_type_model.addCommentTag(tag_data);
    }

    function removeCommentTag(tag) {
        assessment_type_model.deleteCommentTag(tag);
    }

    $: loadAssessmentType(params.id);
</script>

<Loader loading={!$assessment_type || !$library_tags}>
    <div class="container viewport is-fluid">
        <div class="columns">
            <div class="column is-3">
                <AssessmentTypeNav assessment_type_id={params.id}></AssessmentTypeNav>
                <h1 class="title is-1">{$assessment_type.details.name}</h1>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="question_tags">
                    <h2 class="title is-2">Question Tags</h2>
                    <div class="content">
                        <form on:submit|preventDefault={addTag}>
                            <div class="field has-addons">
                                <p class="control">
                                    <span class="select">
                                        <select name="color_class">
                                            <option value="info">Blue</option>
                                            <option value="success">Green</option>
                                            <option value="warning">Yellow</option>
                                            <option value="danger">Red</option>
                                        </select>
                                    </span>
                                </p>
                                <p class="control">
                                  <input class="input" type="text" name="name" placeholder="Tag">
                                </p>
                                <p class="control">
                                  <button class="button is-primary">
                                    Add Tag
                                  </button>
                                </p>
                            </div>
                        </form>
                    </div>
                    <div class="field is-grouped is-grouped-multiline">
                        {#each $assessment_type.question_tags as tag (tag.tag_id)}
                            <div class="field has-addons">
                                <p class="control">
                                    <button
                                        class="button is-{tag.color_class}"
                                        class:is-light={button_toggle[tag.tag_id]}
                                        on:click={() => button_toggle[tag.tag_id] = !button_toggle[tag.tag_id]}
                                    >
                                        <span>{tag.name}</span>

                                        {#if tag.library_id}
                                            <span class="icon is-small"><Fa icon={faBook}></Fa></span>
                                        {/if}
                                    </button>
                                </p>
                                <p class="control">
                                    <button class="button is-light" on:click={() => removeTag(tag)}>
                                        X
                                    </button>
                                </p>
                            </div>
                        {/each}
                    </div>
                        <h2 class="title is-3">Library Tags</h2>
                    <div class="buttons">
                        {#each [...$library_tags] as library_tag}
                            <button
                                class="button is-light is-{library_tag.color}"
                                on:click={() => addLibraryTag(library_tag)}
                            >
                                <span>{library_tag.name}</span>

                                <span class="icon is-small"><Fa icon={faBook}></Fa></span>
                            </button>
                        {/each}
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="question_tags">
                    <h2 class="title is-2">Comment Tags</h2>
                    <div class="content">
                        <form on:submit|preventDefault={addCommentTag}>
                            <div class="field has-addons">
                                <p class="control">
                                    <span class="select">
                                        <select name="color_class">
                                            <option value="info">Blue</option>
                                            <option value="success">Green</option>
                                            <option value="warning">Yellow</option>
                                            <option value="danger">Red</option>
                                        </select>
                                    </span>
                                </p>
                                <p class="control">
                                  <input class="input" type="text" name="name" placeholder="Tag">
                                </p>
                                <p class="control">
                                  <button class="button is-primary">
                                    Add Tag
                                  </button>
                                </p>
                            </div>
                        </form>
                    </div>
                    <div>
                        {#each $assessment_type.comment_tags as tag}
                            <div class="field has-addons">
                                <p class="control">
                                    <button class="button is-{tag.color_class}" class:is-light={button_toggle[tag.tag_id]} on:click={() => button_toggle[tag.tag_id] = !button_toggle[tag.tag_id]}>{tag.name}</button>
                                </p>
                                <p class="control">
                                    <button class="button is-light" on:click={() => removeCommentTag(tag)}>
                                        X
                                    </button>
                                </p>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>
        </div>
    </div>
</Loader>

<style>
    .columns {
        margin: 0;
    }
    .question_tags {
        padding: 0 .75rem;
    }

    .field.has-addons {
        margin-right: .5em;
    }
</style>